const addToast = (kind, message, timeout) => {
  return {
    type: 'ADD_TOAST',
    payload: {
      kind,
      message,
      timeout,
    },
  };
};

export const addToastWithTimeout = (
  kind,
  message,
  customTimeout = 3000
) => dispatch => {
  dispatch(addToast(kind, message, customTimeout));
};
